export default {
  settings: {
    changeSettingsPasscode: 'Einstellungen PIN ändern',
    chooseDefaultSurvey: 'Standardumfrage auswählen',
    congratulations: 'Herzlichen Glückwunsch!',
    downloadSurveys: 'Die neuesten Umfrageeinstellungen herunterladen',
    heading: 'Einstellungen',
    lastSynchronised: 'Gerät zuletzt synchronisiert: {n}',
    // not in use
    lastUploaded: 'Umfragen zuletzt hochgeladen: {n}',
    // not in use
    manageTeam: 'Team verwalten',
    never: 'Nie',
    resetConfirmation: 'Sind Sie sicher, dass Sie dieses Gerät zurücksetzen möchten?',
    resetDevice: 'Gerät zurücksetzen',
    resetError: 'Wir konnten Ihr Gerät nicht deregistrieren. Dies muss manuell über das Backoffice erfolgen.',
    resetSuccess: 'Wir haben Ihr Gerät erfolgreich zurückgesetzt.',
    resetWait: 'Bitte warten Sie, während wir Ihr Gerät zurücksetzen.',
    surveysDownloaded: 'Die neuesten Umfrageeinstellungen wurden erfolgreich heruntergeladen.',
    surveysDownloadError: 'Wir konnten die Umfrageeinstellungen nicht herunterladen.',
    surveysDownloading: 'Bitte warten Sie, während wir die neuesten Umfrageeinstellungen herunterladen.',
    surveysUploaded: 'Wir konnten keine abgeschlossenen Umfragen hochladen | {surveys} abgeschlossene Umfrage wurde erfolgreich hochgeladen. | {surveys} abgeschlossene Umfragen wurden erfolgreich hochgeladen.',
    surveysUploadError: 'Wir konnten die verbleibenden abgeschlossenen Umfragen nicht hochladen | Wir konnten die verbleibenden {surveys} abgeschlossenen Umfragen nicht hochladen.',
    surveysUploadErrorTitle: 'Fehler beim Hochladen von Umfragen',
    surveysUploading: 'Bitte warten Sie, während wir abgeschlossene Umfragen hochladen...',
    surveyUploadedCount: 'Hochgeladen: {n}',
    uploadSurveys: 'Keine Umfragen zum Hochladen | Abgeschlossene Umfrage hochladen ({n}) | Abgeschlossene Umfragen hochladen ({n})',
    updateApp: 'App aktualisieren',
    appUpdating: 'Bitte warten Sie, während wir die neuesten Updates installieren...',
    appUpdated: 'App aktualisiert',
    updateAvailable: 'Eine neue Version der App ist verfügbar. Bitte laden Sie die neueste Version herunter.',
    menuInsights: {
      download: 'Produkte herunterladen',
      downloading: 'Bitte warten Sie, während wir Ihre Produkte herunterladen',
      complete: 'Herzlichen Glückwunsch! Die neuesten Produkte wurden erfolgreich heruntergeladen',
      error: 'Wir konnten die neuesten Produkte nicht herunterladen'
    },
    isStandAlone: 'Standalone-Modus: ',
    isAPK: 'APK-Modus: ',
    pwaStatuses: 'PWA-Status',
    pwaMode: 'Läuft im Modus: ',
    pwaModes: {
      apk: 'Installierte APK',
      pwa: 'Installierte PWA',
      web: 'Webbrowser'
    },
    yes: 'Ja',
    no: 'Nein'
  }
};